import classNames from 'classnames';

import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { getWarningBannerTopOffset } from 'components/weather-warning/utils/manageSlug.js';
import { REDUX_APP_SET_WEATHER_WARNING_BANNER } from 'redux-state/app/reducer.js';
import { useAppDispatch } from 'redux-state/configure-store.js';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { DATE_TIME_FORMAT_ISSUED, formatDate } from 'utilities/date.js';
import { getSeverityInfo } from 'utilities/weather-warnings/warning-severity.js';
import { buildDataSlug } from 'utilities/weather-warnings/warnings.js';
import { getWindow } from 'utilities/window.js';

interface IProps {
  warning: IWarning;
  hideDate?: boolean;
  className?: string;
}

const getInlineText = ({ issuedAt, threatPeriod }: Pick<IWarning, 'issuedAt' | 'threatPeriod'>) => {
  if (threatPeriod) {
    return `Period: ${threatPeriod}`;
  } else if (issuedAt) {
    return `Issued: ${formatDate(issuedAt, DATE_TIME_FORMAT_ISSUED)}`;
  }
  return '';
};

export const InlineWarningComponent = ({ warning, hideDate, className }: IProps) => {
  const appDispatch = useAppDispatch();

  const { icon, name, warnLevel, onlyShowInBanner } = warning;
  if (onlyShowInBanner) {
    return null;
  }
  const warningClasses = classNames('InlineWarning', className);
  const { iconColor } = getSeverityInfo(warnLevel);
  const inlineText = !hideDate ? getInlineText(warning) : undefined;

  const content = (
    <div className="InlineWarning-leftContainer">
      <IconWithText
        icon={`${String(icon)}-${iconColor}` as IconNameV1}
        classes="IconWithText--vCenter IconWithText--small"
      >
        <p className="small u-textSemibold u-mT-0 u-mB-0">{name}</p>
      </IconWithText>
      {inlineText && <span className="fineprint u-textGrey u-mT-0 u-mB-0 u-md-mR-sm u-sm-mB-xs">{inlineText}</span>}
    </div>
  );

  /**
   * This is a hack as there are only two ways to build has links,
   * If we only use hash link, it doesnt work on first click as there is no hash in current state
   * If we only use dispatch setStateHasj it only works on first click
   * @Todo refactor hashlink to allow it to work on first click when hash is not already in the state
   * @todo need a better way of identifying unique warnings
   * @todo how to highlight div without it being link
   * */
  // if (currentHash !== buildDataSlug(warning)) {
  return (
    <div
      className={warningClasses}
      onClick={() => {
        const yPos = getWarningBannerTopOffset();
        setTimeout(() => {
          getWindow()?.scrollTo({
            top: yPos,
            behavior: 'smooth',
          });
        }, 200);
        // open warnings banner and set id of warning component
        appDispatch(
          REDUX_APP_SET_WEATHER_WARNING_BANNER({ isOpen: true, weatherWarningTarget: buildDataSlug(warning) }),
        );
      }}
    >
      {content}
    </div>
  );
};
